module.exports = __webpack_public_path__ + "static/media/Group_3579.31d9c06a.png";